/**
* ページ情報管理
*/

const actions = {
  /** ページ情報のセット */
  setNotice({ commit }, noticeData) {
    commit('setNotice', noticeData);
  },
};

const mutations = {
  setNotice(state, args) {
    state.name = args.name;
    state.link = args.link || null;
    state.data = args.data || null;
    state.autoClose = args.autoClose || false;

    // 一定時間で閉じる
    const closeTime = 3; // 秒
    if (args.name) {
      if (state.timerId) clearTimeout(state.timerId);
      if (args.autoClose) {
        state.timerId = setTimeout(() => {
          state.name = null;
          state.link = null;
          state.data = null;
        }, closeTime * 1000);
      }
    } else if (state.timerId) {
      clearTimeout(state.timerId);
      state.timerId = null;
    }
  },
};

const state = {
  name: null,
  link: null,
  data: null,
  autoClose: false,
  timerId: null,
};

export default {
  namespaced: true,
  actions,
  mutations,
  state,
};
